// extracted by mini-css-extract-plugin
export var infoRow = "_pk-2";
export var labelContainer = "_pk-0";
export var rightInfo = "_pk-1";